'use strict';

import React from 'react';

export {SelectTwo};

class SelectTwo extends React.Component {

    constructor(props) {
        super(props);
        this.ref_input = React.createRef();
    }

    /**
     * Add select2 bind and send onChange manually
     */
    componentDidMount() {

        const self = this;
        $(self.ref_input.current).select2({
            //tags: true,
            minimumInputLength: this.props.minimumInputLength,
            minimumResultsForSearch: this.props.minimumResultsForSearch,

            dropdownCssClass: this.props.dropdownCssClass,
            ajax: this.props.ajax,
            placeholder: this.props.placeholder,
            cache: false,

            language: {
                inputTooShort: function() {
                    return lajax.t('Введите два или более символов');
                },
                searching: function() {
                    return lajax.t('Поиск');
                },
                noResults: function() {
                    return lajax.t('Не найдено');
                }
            },
        }).on('change', function(event) {

            var value = $(event.currentTarget).val();
            if(self.props.multiple === true) {
                value = List(value);
            }

            if(self.props.onChange && value && value != self.props.value){
                self.props.onChange(self.props.name, value);
            }
        });

    }

    /**
     * Emit change event for reload select2 if options has change
     */
    componentDidUpdate(prevProps) {
        if(JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
            $(this.ref_input.current).change();
        }
    }

    render() {

        return (<select className="form-control"
               multiple={this.props.multiple}
               name={this.props.name}
               id={this.props.id ? this.props.id : this.props.name}
               value={this.props.value}
               //onChange={(e) => this.props.onChange(this.props.name, e.target.value)}
               disabled={this.props.disabled}
               ref={this.ref_input}>
            {this.props.children ? this.props.children : renderOptions(this.props.items)}
        </select>)
    }
}

function renderOptions(items) {
    if(items) {
        return items.map(function (item) {
            return <option key={item[0]} value={item[0]} data-value={typeof item[2] != 'undefined' ? item[2] : ''}>{item[1]}</option>
        })
    }
}
